import { createPresentation } from "../../../packages/shared/presentation";
import hawkLogo from "@/assets/hawk_logo.svg";
import presidencyArms from "@/assets/bj/pr.png";
import marinaLogo from "@/assets/bj/marina.png";
import { createPresentationTerminology } from "./presentation-terminology";

export const presentation = createPresentation(
  import.meta.env?.VITE_HAWK_PRESENTATION,
  import.meta.env?.VITE_HAWK_ORGANIZATION_NAME,
);

export const terminology = createPresentationTerminology(presentation.isGeneric);

export const organizationLogo = presentation.isGeneric ? hawkLogo : presidencyArms;
export const invitationLogo = presentation.isGeneric ? hawkLogo : marinaLogo;
export const organizationLogoAlt = presentation.label("Armoiries de la Présidence du Bénin", "Hawk");
